import axios from '../utils/request'
import store from '../store'
import * as Sentry from '@sentry/browser'

export const getMonitoringData = (businessId) => {
  const token = store.state.account.token
  if (!businessId) {
    Sentry.captureException('Business id is missing')
    return
  }
  return axios({
    baseURL: `${process.env.VUE_APP_DRIP_API_HOST}`,
    method: 'GET',
    url: `/v2/business/exporters/${businessId}/monitoring_data`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

export default { getMonitoringData }
